const CachedImageWidthSteps = [1000, 1600, 2000];

/**
 * Returns the nearest width of a higher value.
 * For example,
 * - if the value is 1, the function will return 600.
 * - if the value is 601, the function will return 800.
 * - if the value is 1199, the function will return 1200.
 * - if the value is greater than 1200, the function will return 1200.
 */
export const intToCachedPDFImageWidth = (value: number) => {
    const widths = [...CachedImageWidthSteps].sort((a, b) => a - b);
    const highestWidth = widths.filter((width) => width >= value)[0];

    return highestWidth || widths[widths.length - 1];
};

/**
 * Builds a url using a path and params 'page' and 'width'.
 */
export const buildCachedPDFUrl = (
    path: string,
    page: number,
    width: number,
): string => {
    const params = new URLSearchParams({
        page: String(page),
        width: String(width),
    });
    return `${path}?${params.toString()}`;
};
